<template>
  <div>
    <section
      v-if="memberships.length"
      class="flex flex-wrap items-stretch -mx-2"
    >
      <Card
        v-for="membership in memberships"
        :key="membership.uuid"
        :membership="membership"
      />
    </section>
    <div
      v-if="!memberships.length"
      class="w-full empty"
    >
      <section>
        <h2 v-text="'No results'" />
      </section>
    </div>
  </div>
</template>

<script type="text/babel">
import Card from 'Membership/Resources/assets/js/components/MembershipCard'

export default {
  name: 'MembershipsCardView',
  components: {
    Card,
  },
  props: {
    memberships: {
      type: Array,
      required: true,
    },
  },
}
</script>
